import { DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { StepInput } from './StepInput'
import { StepNavigation } from './StepNavigation'
import { promptSteps } from './promptStepConfig'
import { FormValues } from '@/hooks/usePromptForm'

interface FormStepsProps {
  currentStep: number;
  values: FormValues;
  uploading: boolean;
  uploadedFiles: Array<{ name: string; url: string }>;
  onInputChange: (field: keyof FormValues, value: string) => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (file: { name: string; url: string }) => void;
  onNext: () => void;
}

export const FormSteps = ({
  currentStep,
  values,
  uploading,
  uploadedFiles,
  onInputChange,
  onFileChange,
  onRemoveFile,
  onNext
}: FormStepsProps) => {
  const step = promptSteps[currentStep]

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-xl mb-4">
          {step.title}
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <StepInput
          step={step}
          value={values[step.field as keyof FormValues]}
          uploading={uploading}
          uploadedFiles={uploadedFiles}
          onInputChange={(value) => onInputChange(step.field as keyof FormValues, value)}
          onFileChange={onFileChange}
          onRemoveFile={onRemoveFile}
        />
        <StepNavigation
          currentStep={currentStep}
          totalSteps={promptSteps.length}
          onNext={onNext}
          isLastStep={currentStep === promptSteps.length - 1}
        />
      </div>
    </>
  )
}